import { FieldProps } from "@rjsf/utils";
import FormMultiSelect from "../FormMultiSelect/FormMultiSelect";
import { IPortfolioMetadata } from "@pulse-ui/codegen/generated_ts/org_metadata";

interface IPortfolioMultiSelectProps extends FieldProps {
  portfolios: string[];
  org_metadata: { portfolios: IPortfolioMetadata[] };
  rootFormData?: any;
}

const PortfolioMultiSelect = (props: IPortfolioMultiSelectProps) => {
  const { formData, onChange, portfolios, org_metadata, rootFormData } = props;

  const getPortfolioDisplayName = (portfolio_id: string) => {
    const portfolioMetadata = org_metadata.portfolios.find(
      (item) => item.portfolio_id === portfolio_id
    );
    return portfolioMetadata ? portfolioMetadata.display_name : portfolio_id;
  };

  // Get the main portfolio field value
  const mainPortfolioValue = rootFormData?.portfolio || "";

  // Get currently selected additional portfolios
  const selectedAdditionalPortfolios = formData || [];

  // Filter out the main portfolio and already selected portfolios
  const filteredPortfolios = portfolios.filter((portfolio: string) => {
    return (
      portfolio !== mainPortfolioValue &&
      !selectedAdditionalPortfolios.includes(portfolio)
    );
  });

  // Create options for available portfolios
  const availableOptions = filteredPortfolios.map((portfolio: string) => ({
    label: getPortfolioDisplayName(portfolio),
    value: portfolio,
  }));

  // Create options for currently selected portfolios (to ensure they have proper labels)
  const selectedOptions = selectedAdditionalPortfolios.map(
    (portfolio: string) => ({
      label: getPortfolioDisplayName(portfolio),
      value: portfolio,
    })
  );

  // Combine all options (available + selected) to ensure proper labels
  const allOptions = [...availableOptions, ...selectedOptions];

  const handleChange = (newValue: string[]) => {
    onChange(newValue);
  };

  return (
    <FormMultiSelect
      {...props}
      options={allOptions}
      value={formData || []}
      onChange={handleChange}
      setInputValue={() => {}}
    />
  );
};

export default PortfolioMultiSelect;
